import React from 'react';
import GlobalStyle from './GlobalStyle';
import { ThemeProvider } from 'styled-components/macro';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import defaultTheme from './themes';
import Landing from './components/landing/Landing';
import { PreferencesProvider } from './contexts/preferences';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <React.Fragment>
      <GlobalStyle />

      <ThemeProvider theme={defaultTheme}>
        <Router>
          <PreferencesProvider>
            <ScrollToTop />

            <Switch>
              <Redirect from="/terms" to="/tos" />
              <Route path="/" component={Landing} />
            </Switch>
          </PreferencesProvider>
        </Router>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
